export const Gif = ({ width, gif, onGifClick }) => (
  <a href="#insert" onClick={event => onGifClick(gif, event)}>
    <img loading="lazy" alt="" width={width} src={gif.images.preview_gif.url} />
  </a>
);
